const ESCALATE = "Send this page to engineering, including the failed step and its detail.";

/**
 * What a failed connection check means, for support: none of these are
 * something they can fix, so each ends by sending it on. Keyed on the step
 * names the check reports; an unknown step is named rather than guessed at.
 */
export function connectionCheckFailureCopy(failedAt: string): { title: string; message: string } {
  if (failedAt === "secret") {
    return {
      title: "Credentials aren't set up",
      message: `a3s has no Patriot sign-in details for this environment. ${ESCALATE}`,
    };
  }
  if (failedAt === "dns" || failedAt === "tcp" || failedAt === "tls") {
    return {
      title: "a3s can't reach Patriot",
      message: `The network path from a3s to Patriot isn't working. ${ESCALATE}`,
    };
  }
  if (failedAt === "token") {
    return {
      title: "Patriot rejected the sign-in",
      message: `The Patriot account's username or password was refused. ${ESCALATE}`,
    };
  }
  if (failedAt.startsWith("read:")) {
    return {
      title: "Missing Patriot access",
      message: `a3s signed in but isn't allowed to read some records. Every lane it can't read is marked Failed below. ${ESCALATE}`,
    };
  }
  return { title: `Failed at ${failedAt}`, message: ESCALATE };
}
